export const NEW_CAR_RESOURCES_CONTENT_PATH = '/editorial/includes/venom/new-car-resources';
export const MOST_RESEARCHED_VEHICLES_CONTENT_PATH = '/editorial/includes/venom/most-researched-vehicles';
export const TOP_MAKES_CONTENT_PATH = 'research/global/top-makes';
export const RESEARCH_SUBNAV_CONTENT_PATH = 'research/includes/research-rr-navigation';
export const SELL_CAR_CONTENT_PATH = 'research/sell-car/index-new';
export const PRESS_RIGHT_RAIL = 'editorial/includes/industry/press-right-rail';
